import styled from "styled-components";

export const Header = styled.h3`
  color: rgba(16, 15, 87, 0.49);
  font-size: 12px;
  font-weight: bold;
`;

export const GlobContainer = styled.div`
  margin: 5.6rem 3rem 0 3rem;
`;
